import React from "react";

const Accordion = ({ title, expand, onClick, expandedItem }) => (
  <div className="accordion-main">
    <dl className="accordion">
      <div>
        <dt
          className={expand ? "title is-expanded" : "title"}
          onClick={onClick}
        >
          {title}
        </dt>
        <dd
          className={expand ? "content is-expanded" : "content"}
          onClick={onClick}
        >
          <p>{expandedItem}</p>
        </dd>
      </div>
    </dl>
  </div>
);

export default Accordion;
